import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import hiitF20Png from '@/assets/landing-activity-female/hiit-f-20.png'
import hiitF30Png from '@/assets/landing-activity-female/hiit-f-30.png'
import activitySeniorF40Webp from '@/assets/landing-activity-female/activity-senior-f-40.webp'
import activitySeniorF50Webp from '@/assets/landing-activity-female/activity-senior-f-50.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'CALISTHENICS <br/>WORKOUT PLAN',
			size: 'large',
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: (): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: 'Age: 18-29',
					img: hiitF20Png,
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: 'Age: 30-39',
					img: hiitF30Png,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: 'Age: 40-49',
					img: activitySeniorF40Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: 'Age: 50+',
					img: activitySeniorF50Webp,
				},
			],
		}),
	},
}

export default schema
